import _ from 'lodash'
import React, { useState, useLayoutEffect } from 'react'
import { Button, FormControl, FormGroup, Label } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import LiveTooltip from 'live/components/ui/tooltip'

import { SwitchButtonWithTrigger } from 'plugin-generic-components/shared/components/components'
import { PresenterProps } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'

import { Escalation, RemoveEscalation, UpdateMode } from './style'

type IUpdateModeJsonConfigConfig = {
    initialContribution: number | string
}
type IEditorEscalation = import('plugin-codaf-risk-ext-bowtie/types').IEscalationFactor & { uid: string }

export const QuantitativeLopaScalingWithContribution: React.FC<PresenterProps> = ({
    barrierPointers,
    onChanged,
    editable
}) => {
    // PASER WILL BE DONE ATE UPDATE MODE CONTROLLER

    const escalationInitialContributionValidator = (
        updateModeJsonConfig: IUpdateModeJsonConfigConfig
    ): 'error' | 'success' => {
        return !updateModeJsonConfig?.initialContribution ||
            isNaN(updateModeJsonConfig?.initialContribution as any) ||
            updateModeJsonConfig?.initialContribution < 0 ||
            updateModeJsonConfig?.initialContribution > 1
            ? 'error'
            : 'success'
    }

    useLayoutEffect(() => {
        if (barrierPointers) {
            if (!barrierPointers[0].escalations || barrierPointers[0].escalations.length === 0) {
                handleAddEscalationFactor()
            }
        }
    }, [barrierPointers])

    const onDeleteEscalationRequest = (escalationEdit: IEditorEscalation): void => {
        if (barrierPointers[0].root) {
            const newArray = (barrierPointers[0].escalations as IEditorEscalation[]).filter(e => {
                if (e.id) {
                    return e.id !== escalationEdit.id
                } else {
                    return e.uid !== escalationEdit.uid
                }
            })
            barrierPointers[0].escalations = [...newArray]
        } else {
            barrierPointers.forEach(bar => {
                const newArray = (bar.escalations as IEditorEscalation[]).filter(e => {
                    if (e.id) {
                        return e.id !== escalationEdit.id
                    } else {
                        return e.uid !== escalationEdit.uid
                    }
                })
                bar.escalations = [...newArray]
            })
        }

        onChanged()
    }

    const handleAddEscalationFactor = (): void => {
        // const recursiveArrayOfBarrier = handleGetRecursiveSearch(item[0] as IEditorBarrier)

        const escalationToAdd: IEditorEscalation = {
            id: null,
            uid: _.uniqueId(),
            name: null,
            updateModeJsonConfig: { initialContribution: null },
            barriers: []
            // getFather: item[0] as IEditorBarrier
        }

        if (barrierPointers[0].root) {
            if (!barrierPointers[0].escalations.length) {
                barrierPointers[0].escalations = [escalationToAdd]
            } else {
                barrierPointers[0].escalations = [...barrierPointers[0].escalations, escalationToAdd]
            }
        } else {
            if (barrierPointers[0].id) {
                barrierPointers.forEach(bar => {
                    if (!bar.escalations.length) {
                        bar.escalations = [escalationToAdd]
                    } else {
                        bar.escalations = [...bar.escalations, escalationToAdd]
                    }
                })
            } else {
                if (!barrierPointers[0].escalations.length) {
                    barrierPointers[0].escalations = [escalationToAdd]
                } else {
                    barrierPointers[0].escalations = [...barrierPointers[0].escalations, escalationToAdd]
                }
            }
        }

        onChanged()
    }
    const escalationsFields = barrierPointers[0].escalations.map((escalation, index) => {
        return (
            <Escalation key={index}>
                <FormGroup validationState={barrierPointers[0].escalations[index].name ? 'success' : 'error'}>
                    <Label required className="control-label">
                        {i18n('Escalation Factor')} #{index + 1}*
                    </Label>
                    <FormControl
                        readOnly={!editable}
                        type="text"
                        componentClass="textarea"
                        onChange={e => {
                            barrierPointers.forEach(
                                el => (el.escalations[index].name = (e.target as HTMLInputElement).value)
                            )
                            onChanged()
                        }}
                        id="barrierEditor-barrierEditModal-field-lopaScaling-escalationFactor"
                        value={escalation.name}
                    />
                </FormGroup>
                <FormGroup
                    validationState={escalationInitialContributionValidator(
                        barrierPointers[0].escalations[index].updateModeJsonConfig as IUpdateModeJsonConfigConfig
                    )}
                    className="escalationfactor-ic-box"
                >
                    <Label required className="control-label">
                        <LiveTooltip content={i18n('Initial Contribution')} position="left">
                            <div>IC*</div>
                        </LiveTooltip>
                    </Label>
                    <FormControl
                        readOnly={!editable}
                        type="number"
                        componentClass="textarea"
                        onChange={e => {
                            barrierPointers.forEach(
                                el =>
                                    ((el.escalations[index].updateModeJsonConfig as IUpdateModeJsonConfigConfig) = {
                                        initialContribution: (e.target as HTMLInputElement).value
                                    })
                            )
                            onChanged()
                        }}
                        id="barrierEditor-barrierEditModal-field-lopaScaling-escalationFactor-initial-contribution"
                        value={(escalation?.updateModeJsonConfig as IUpdateModeJsonConfigConfig)?.initialContribution}
                    />
                </FormGroup>
                {editable && (
                    <RemoveEscalation>
                        {barrierPointers[0].escalations.length > 1 && (
                            <button onClick={() => onDeleteEscalationRequest(escalation as IEditorEscalation)}>
                                <i className="far fa-trash-alt"></i>
                            </button>
                        )}
                    </RemoveEscalation>
                )}
            </Escalation>
        )
    })

    return (
        <>
            <UpdateMode>
                <SwitchButtonWithTrigger
                    id={'escalationFactor'}
                    label={i18n('Escalation Factors')}
                    value={true}
                    disabled
                />
                <div className="escalations">{escalationsFields}</div>
                <Button
                    disabled={!editable}
                    className="add-escalation-button"
                    bsStyle="primary"
                    onClick={handleAddEscalationFactor}
                >
                    <i className="fas fa-plus"></i> {i18n('add escalation')}
                </Button>
            </UpdateMode>
        </>
    )
}
